
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';

const data = [
  { bucket: '0-1M', gap: 120, cumulativeGap: 120 },
  { bucket: '1-3M', gap: 85, cumulativeGap: 205 },
  { bucket: '3-6M', gap: -65, cumulativeGap: 140 },
  { bucket: '6-12M', gap: -110, cumulativeGap: 30 },
  { bucket: '1-3Y', gap: -45, cumulativeGap: -15 },
  { bucket: '3-5Y', gap: 80, cumulativeGap: 65 },
  { bucket: '>5Y', gap: 35, cumulativeGap: 100 },
];

const RepricingGapChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bucket" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`₹${value} Cr`, undefined]}
          labelFormatter={(label) => `Time Bucket: ${label}`}
        />
        <Legend />
        <ReferenceLine y={0} stroke="#666" />
        <Bar dataKey="gap" name="Gap" fill="#3b82f6" />
        <Bar dataKey="cumulativeGap" name="Cumulative Gap" fill="#22c55e" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RepricingGapChart;
